export const environment = {
  appname: 'Veyora Fit',
  host: 'https://veyorafit.com',
  facebook: 'https://www.facebook.com/veyorafit',
  email: 'support@veyorafit.com',
  address1: '1101 S York St',
  address2: 'Denver, CO 80210',
  free_shipping_threshold: 300,
  collection: {
    new_arrivals: 'new-arrivals',
    best_sellers: 'best-sellers',
  },
  api: {
    host: 'https://veyorafit.com/api',
    s3endpoint: 'https://storage.veyorafit.com',
  },
  google: {
    reCaptcha: {
      siteKey: '6LfZ1RYtAAAAADB6kWkhXIExXu8-ATvGUXV5pY8w',
    },
    oauth: {
      clientID:
        '642873476515-d5duqhcuc1ofeq87gvqtgseg3q0n75ve.apps.googleusercontent.com',
    },
    api: {
      place: 'AIzaSyCL2N48eT0s1oeO4d5SKi3WBTLUlvEtKXM',
    },
  },
  stripe: {
    apikey:
      'pk_live_51TOu7MAEFDlGV411WkOmeYqr4MTzox1s8slbMpI14PfSxUb4USrHiDZaPHCDiKdykZmXUDXhmRkEwqfIZALh07gG00hBLZtlLD',
  },
};
